import { render } from "./PriceTableColumnCrud.vue?vue&type=template&id=f7378fc4&scoped=true&ts=true"
import script from "./PriceTableColumnCrud.vue?vue&type=script&lang=ts"
export * from "./PriceTableColumnCrud.vue?vue&type=script&lang=ts"

import "./PriceTableColumnCrud.vue?vue&type=style&index=0&id=f7378fc4&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7378fc4"]])

export default __exports__